import React, { useContext, useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import FormTemplate from '../../../components/FormTemplate';
import InputDefault from '../../../components/InputDefault';
import InputFile from '../../../components/InputFile';
import Select from '../../../components/Select';
import { dataSolicitationSteps, segments } from '../../../helpers/enum';
import { DefaultLargeButton, SecondaryLargeButton } from '../../../components/Buttons/styles';
import Loader from '../../../components/Loader';
import InputDate from '../../../components/InputDate';
import InputPhone from '../../../components/InputPhone';
import { useDropzone } from 'react-dropzone';
import { Form, FormFooter, FormRow } from '../../../components/FormTemplate/styles';
import { default as DataSolicitationTypes } from '../../../store/DataSolicitation/types';
import { handleChangeIdentification as handleChangeNumeroAfiliacion } from '../../../helpers/price';
import { DataSolicitationContext } from '../../../store/index';
import { getBranches, getStates } from '../../../services/states';
import { getTipoPension } from '../../../services/pension';
import { getCities } from '../../../services/cities';
import { getDocumentTypes } from '../../../services/document';
import { saveWorkData } from '../../../services/dataSolicitation';
import ModalInfo from '../../../components/ModalInfo';
import colors from '../../../assets/styles/colors';
import { BsExclamation } from 'react-icons/bs';
import { useLocation } from 'react-router-dom';
import { numeroAfiliacionPensionado } from '../../../helpers/enum';
import { getContractTypes } from '../../../services/extract';

const OldWorkDataPage = ({ setActiveStep, setLastStep }) => {
  const location = useLocation();
  const { dataSolicitation, setDataSolicitation } = useContext(DataSolicitationContext);
  const { getRootProps, getInputProps } = useDropzone({ onDrop });
  const { control, register, errors, clearErrors, setValue, watch, handleSubmit, trigger } = useForm({ defaultValues: dataSolicitation.workData });
  const [showActivity, setShowActivity] = useState(false);
  const [documentTypes, setDocumentTypes] = useState([]);
  const [showDocumentTypes, setShowDocumentTypes] = useState(false);
  const [branches, setBranches] = useState([]);
  const [showBranches, setShowBranches] = useState(false);
  const [tipoPensionList, setTipoPensionList] = useState([]);
  const [showTipoPension, setShowTipoPension] = useState(false);
  const [tipPension, setTipPension] = useState('');
  const [canAddFile, setCanAddFile] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [showModalInfoTelefono, setShowModalInfoTelefono] = useState('');
  const [showModalInfoNumeroAfiliacion, setShowModalInfoNumeroAfiliacion] = useState('');
  const [isColpensiones, setIsColpensiones] = useState(false);
  const fields = watch();
  const [showContractType, setShowContractType] = useState(false);
  const [contractTypes, setContractsType] = useState([]);

  async function initializeStateComponent() {
    try {
      const states = await getStates();
      const state = states.data.find(item => item.id === dataSolicitation.workData.data.pagaduria.idDepartamento)
      const cities = await getCities(dataSolicitation.workData.data.pagaduria.idDepartamento);
      const city = cities.data.find(item => item.id === dataSolicitation.workData.data.pagaduria.idCiudad)
      const contractTypes = await getContractTypes(dataSolicitation.basicData.actividadCliente.id ? dataSolicitation.basicData.actividadCliente.id : dataSolicitation.basicData.actividadCliente);

      if (dataSolicitation.basicData.tipoContrato) {
        contractTypes.data.map((item) => {
          if (item.nombre == dataSolicitation.basicData.tipoContrato) {
            selectContractType(item);
          }
        });
      }
      setContractsType(contractTypes.data);
      const branchesResponse = await getBranches(dataSolicitation.solicitation.pagaduria.id);
      const response = await getDocumentTypes('DATOS_LABORALES');
      //const tipoPensionResponse = await getTipoPension();

      setDocumentTypes(response.data);
      setBranches(branchesResponse.data);
      //setTipoPensionList(tipoPensionResponse.data);

      autoCompleteData({
        state,
        city
      });

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error.response)
    }
  }

  function autoCompleteData(data) {
    setValue('empresaTrabajo', dataSolicitation.workData.data.pagaduria.nombre);
    setValue('departamentoTrabajo', data.state.nombre);
    setValue('ciudadTrabajo', data.city.nombre);
    if (isPagaduriaColpensiones(dataSolicitation.workData.data.pagaduria.nombre)) {
      setIsColpensiones(true);
    }
    setTipPension(dataSolicitation.workData?.tipoPension || dataSolicitation.lastCredit?.tipoPension || '');
    setValue('nitAfiliacion', dataSolicitation.lastCredit?.nitAfiliacion || '');
    setValue('fechaIngreso', dataSolicitation.lastCredit?.fechaIngreso || '');
  }

  async function setCompleteStep(data) {
    try {
      const tel = data.telefonoOficina.trim();
      if ((tel.length > 0 && tel[0] < 2) || (tel.length != 10 && tel.length != 0)) {
        setShowModalInfoTelefono(true);
        return;
      }
      let nitAfiliacion = data.nitAfiliacion || '';
      if (isColpensiones) {
        if (!nitAfiliacion || nitAfiliacion.length < numeroAfiliacionPensionado.min || nitAfiliacion.length > numeroAfiliacionPensionado.max) {
          setShowModalInfoNumeroAfiliacion(true);
          return;
        }
      }
      setIsLoading(true);
      const req = new FormData();

      await setDataSolicitation({
        type: DataSolicitationTypes.SET_WORK_DATA,
        workData: {
          ...dataSolicitation.workData,
          tipoPension: data.tipoPension,
          cargo: data.cargo,
          fechaIngreso: data.fechaIngreso,
          telefonoOficina: data.telefonoOficina,
          extension: data.extension,
          nitAfiliacion: nitAfiliacion,
          tipoDocumento: dataSolicitation.workData.tipoDocumento,
          certificacionLaboral: dataSolicitation.workData.certificacionLaboral
        }
      })

      req.append('idCredito', location.idCredit)
      req.append('fechaIngreso', data.fechaIngreso);
      req.append('actividad', dataSolicitation.credit.actividad);
      req.append('nitAfiliacion', nitAfiliacion);

      if (dataSolicitation.workData.branch.id) {
        req.append('idPagaduriaSucursal', dataSolicitation.workData.branch.id);
      }

      if (segments[1].id === dataSolicitation.solicitation.credito.segmento) {
        req.append('tipoPension', dataSolicitation.basicData.tipoContrato.nombre); //Se envia tipo contrato porque en esta variable se almacenan los tipo contrato y pension
      }

      req.append('cargo', data.cargo);
      req.append('idDocumento', dataSolicitation.workData.tipoDocumento.id);
      req.append('telefonoTrabajo', data.telefonoOficina?.replaceAll(' ', ''));
      req.append('exstensionTelefonoTrabajo', data.extension);
      req.append('certificacionLaboral', dataSolicitation.workData.certificacionLaboral[0], dataSolicitation.workData.certificacionLaboral[0].name);

      await saveWorkData(req, location.idCredit, "WEB");
      setIsLoading(false);
      setActiveStep(dataSolicitationSteps.CREDIT_DATA);
      setLastStep(dataSolicitationSteps.WORK_DATA);
    } catch (error) {
      console.log(error)
      console.log(error.response)
      setIsLoading(false);
    }
  }

  function setBackStep() {
    setDataSolicitation({
      type: DataSolicitationTypes.SET_WORK_DATA,
      workData: {
        ...dataSolicitation.workData,
        tipoPension: fields.tipoPension,
        cargo: fields.cargo,
        fechaIngreso: fields.fechaIngreso,
        telefonoOficina: fields.telefonoOficina,
        extension: fields.extension,
        nitAfiliacion: fields.nitAfiliacion || '',
        tipoDocumento: dataSolicitation.workData.tipoDocumento,
        certificacionLaboral: dataSolicitation.workData.certificacionLaboral
      }
    })
    setActiveStep(dataSolicitationSteps.BASIC_DATA);
    /*if(dataSolicitation.basicData.estadoCivil?.id === 'CASADO' || dataSolicitation.basicData.estadoCivil?.id === 'UNION_LIBRE') {
      setActiveStep(dataSolicitationSteps.COMPLEMENT_DATA)
    } else {
      setActiveStep(dataSolicitationSteps.ADITIONAL_DATA)
    }*/
  }

  function setSelectedBranch(branch) {
    setValue('branch', branch.nombre);
    setDataSolicitation({
      type: DataSolicitationTypes.SET_BRANCH,
      branch
    });

    setShowBranches(false);
  }

  function setSelectedTipoPension(tipoPension) {
    setTipPension(tipoPension.nombre);
    setValue('tipoPension', tipoPension.nombre);
    setShowTipoPension(false);
  }

  function selectDocumentType(documentType) {
    setValue("tipoDocumento", documentType);
    clearErrors("tipoDocumento", {});

    setDataSolicitation({
      type: DataSolicitationTypes.SET_WORK_DATA_DOCUMENT_TYPE,
      tipoDocumento: documentType
    })
  }

  function removeFile() {
    setCanAddFile(true);

    setDataSolicitation({
      type: DataSolicitationTypes.REMOVE_WORK_CERTIFICATION_FILE,
      file: []
    });
  }

  function onDrop(file) {
    setCanAddFile(false);

    setDataSolicitation({
      type: DataSolicitationTypes.SET_WORK_CERTIFICATION,
      file
    });
  }

  function isPagaduriaColpensiones(pagaduria) {
    if (!pagaduria) {
      pagaduria = "";
    }
    return pagaduria.toUpperCase().indexOf("PENSION") != -1;
  }

  function selectContractType(contracttype) {
    setValue("tipoDeContrato", contracttype);
    clearErrors("tipoDeContrato", {});

    setDataSolicitation({
      type: DataSolicitationTypes.SET_TIPO_CONTRATO,
      tipoContrato: contracttype
    })

    setShowContractType(false);
  }

  useEffect(() => {
    initializeStateComponent();
  }, [])

  function formatDateToYYYYMMDD(fecha) {
    const anio = fecha.getFullYear();
    const mes = (fecha.getMonth() + 1).toString().padStart(2, '0');
    const dia = fecha.getDate().toString().padStart(2, '0');
    return `${anio}-${mes}-${dia}`;
  }

  const isDateNotFuture = date => {
    const selectedDate = new Date(date);
    const currentDate = new Date();
    return selectedDate <= currentDate;
  };
  
  const handleDateBlur = () => {
    trigger("fechaIngreso");
  };
  

  return (
    <FormTemplate
      idForm="work-data-step-page"
      activeStep="2/4"
      stepLabel="Datos Laborales o Pensionales">
      <Form onSubmit={handleSubmit(setCompleteStep)}>
        {!dataSolicitation.pricing &&
          <FormRow col="2">
            <Select
              error={errors.segment}
              setShow={setShowActivity}
              show={showActivity}
              defaultValue={dataSolicitation.solicitation.credito.segmento}
              setSelected={() => { }}
              list={[]}
              placeholder="Seleccionar..."
              label="Segmento"
              name="segment"
              id="segment"
              register={register({ required: "Este dato es obligatorio" })}
              disabled />
            <Select
              error={errors.tipoContrato}
              setShow={setShowContractType}
              show={showContractType}
              defaultValue={dataSolicitation.basicData.tipoContrato?.nombre}
              setSelected={selectContractType}
              list={contractTypes}
              placeholder={dataSolicitation.basicData.actividadCliente?.nombre ? "Seleccionar..." : "Seleccione una actividad..."}
              label="TIPO DE CONTRATO / PENSIÓN"
              name="tipoDeContrato"
              id="tipoDeContrato"
              register={register({ required: "Este dato es obligatorio" })}
            />
          </FormRow>
        }

        {/*
          <Select
              error={errors.tipoPension}
              setShow={setShowTipoPension}
              show={showTipoPension}
              defaultValue={tipPension}
              setSelected={setSelectedTipoPension}
              list={tipoPensionList}
              placeholder="Seleccionar..."
              label={`Si es Pensionado Seleccione Tipo de pensión ${segments[1].id === dataSolicitation.solicitation.credito.segmento ? '' : '(Opcional)'}`}
              name="tipoPension"
              id="tipoPension"
              register={register(segments[1].id === dataSolicitation.solicitation.credito.segmento ? { required: "Este dato es obligatorio" } : {})}
              disabled={!tipoPensionList.length} />
              */}

        <FormRow col="2">
          {
            isColpensiones && (
              <Controller
                as={InputDefault}
                control={control}
                label="N°. DE AFILIACIÓN"
                name="nitAfiliacion"
                id="nitAfiliacion"
                error={errors.nitAfiliacion}
                value={dataSolicitation.workData.nitAfiliacion}
                maxLength="12"
                type='number'
                register={register({
                  required: "Este dato es obligatorio",
                  pattern: {
                    value: /^[0-9]{12}$/,
                    message: "La identificación de la afiliación es de 12 números",
                  },
                  validate: (value) => {
                    if (value.length !== 12) {
                      return "La identificación de la afiliación es de 12 números";
                    }
                    return true;
                  },
                  max: {
                    value: 999999999999,
                    message: "La identificación de la afiliación es de 12 números",
                  },
                })}
              />
            )
          }
        </FormRow>
        <FormRow col="2">
          <Controller
            as={InputDefault}
            control={control}
            label="Empresa Donde Trabaja"
            name="empresaTrabajo"
            id="empresaTrabajo"
            error={errors.empresaTrabajo}
            value={dataSolicitation.workData.data.pagaduria.nombre}
            register={register}
            readOnly />
          <Controller
            as={InputDefault}
            control={control}
            label="Departamento de la empresa"
            name="departamentoTrabajo"
            id="departamentoTrabajo"
            error={errors.departamentoTrabajo}
            value={dataSolicitation.complementData.pagaduria.nombre}
            register={register}
            readOnly />
        </FormRow>
        <FormRow col="2">
          <Controller
            as={InputDefault}
            control={control}
            label="Ciudad de la empresa"
            name="ciudadTrabajo"
            id="ciudadTrabajo"
            error={errors.ciudadTrabajo}
            value={dataSolicitation.complementData.ciudad.nombre}
            register={register}
            readOnly />
          <Controller
            as={InputDefault}
            control={control}
            label={`Cargo ${segments[0].id === dataSolicitation.solicitation.credito.segmento ? '' : '(Opcional)'}`}
            name="cargo"
            id="cargo"
            error={errors.cargo}
            value={dataSolicitation.workData.cargo}
            register={register(segments[0].id === dataSolicitation.solicitation.credito.segmento ? { required: "Este dato es obligatorio" } : {})} />
        </FormRow>
        <FormRow col="2">
          <InputDate
            aria-required
            type="date"
            label="Fecha de Ingreso o Inicio de Pensión"
            name="fechaIngreso"
            register={register({
              required: "Este dato es obligatorio",
              validate: {
                notFutureDate: value => {
                  return isDateNotFuture(value) || "La fecha no puede ser mayor al presente";
                }
              }
            })}
            id="fechaIngreso"
            onBlur={handleDateBlur}
            error={errors.fechaIngreso}
            max={formatDateToYYYYMMDD(new Date())}
          />
        </FormRow>
        <FormRow>
          <Controller
            as={InputPhone}
            control={control}
            label="Tel. Oficina - 60 + Ingresar Indicativo (Opcional)"
            name="telefonoOficina"
            value={dataSolicitation.workData.telefonoOficina}
            error={errors.telefonoOficina}
            register={register({
              pattern: {
                value: /^([0-9]{1}) ([0-9]{2}) ([0-9]{2}) ([0-9]{2})$/,
                message: "Error en el número, ingresa uno válido",
              },
            })}
            id="telefonoOficina"
            mask="9 99 99 99" />
          <Controller
            as={InputDefault}
            control={control}
            label="Extensión (Opcional)"
            name="extension"
            id="extension"
            error={errors.extension}
            value={dataSolicitation.workData.extension}
            register={register} />
        </FormRow>
        <FormRow>
          <Select
            error={errors.sucursal}
            setShow={setShowBranches}
            show={showBranches}
            defaultValue={dataSolicitation.workData.branch?.nombre}
            setSelected={setSelectedBranch}
            list={branches}
            placeholder="Seleccionar..."
            label="Sucursal"
            name="sucursal"
            id="sucursal"
            register={register}
            disabled={!branches.length} />
        </FormRow>
        <FormRow col="1">
          <Select
            error={errors.tipoDocumento}
            setShow={setShowDocumentTypes}
            show={showDocumentTypes}
            defaultValue={dataSolicitation.workData.tipoDocumento.nombre}
            setSelected={selectDocumentType}
            list={documentTypes}
            placeholder="Seleccionar..."
            label="Tipo de documento"
            name="tipoDocumento"
            register={register({ required: "Este dato es obligatorio" })}
            id="tipoDocumento" />
        </FormRow>
        <FormRow col="1">
          <InputFile
            getInputProps={getInputProps}
            getRootProps={getRootProps}
            canAddFile={canAddFile}
            files={dataSolicitation.workData.certificacionLaboral}
            removeFile={removeFile}
            description="Elige un archivo PNG, JPEG o JPG, o arrasta aqui." />
        </FormRow>
        <FormFooter justify="space-between">
          <DefaultLargeButton type="button" id="back-step" onClick={() => setBackStep()}>Volver</DefaultLargeButton>
          <SecondaryLargeButton type="submit">Siguiente</SecondaryLargeButton>
        </FormFooter>
        {isLoading && <Loader />}
      </Form>
      <ModalInfo
        open={showModalInfoTelefono}
        setShowModal={setShowModalInfoTelefono}
        title="Teléfono inválido"
        description="Digita un número de telefono válido"
        backgroundIcon={colors.bgDanger}
        bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />
      <ModalInfo
        open={showModalInfoNumeroAfiliacion}
        setShowModal={setShowModalInfoNumeroAfiliacion}
        title="Número de afiliación inválido"
        description="Digita un número de afiliación válido"
        backgroundIcon={colors.bgDanger}
        bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />
    </FormTemplate>
  )
}

export default OldWorkDataPage;
